// =====================================================
// API CONTROLLERS — replaces mock in-memory controllers
// =====================================================
import {
  AccountGroupAPI, AccountSubGroupAPI, BankCashAPI,
  LedgerAPI, BudgetAPI, getSocietyId,
} from './services/api';

export const AccountGroupController = {
  getAll:  ()         => AccountGroupAPI.getAll(),
  add:     (data)     => AccountGroupAPI.create(data),
  update:  (id, data) => AccountGroupAPI.update(id, data),
  delete:  (id)       => AccountGroupAPI.delete(id),
};

export const AccountSubGroupController = {
  getAll:      ()         => AccountSubGroupAPI.getAll(),
  add:         (data)     => AccountSubGroupAPI.create(data),
  update:      (id, data) => AccountSubGroupAPI.update(id, data),
  applyDefaults: (data)   => AccountSubGroupAPI.applyDefaultSubGroups(data),
};

export const BankAccountController = {
  getAll:    ()             => BankCashAPI.getAll(),
  getByType: (type)         => BankCashAPI.getByType(type),
  add:       (data)         => BankCashAPI.create(data),
  update:    (id, data)     => BankCashAPI.update(id, data),
  delete:    (id)           => BankCashAPI.delete(id),
};

export const LedgerController = {
  getAll:              () => LedgerAPI.getPayment(),
  add:                 (d) => LedgerAPI.createPayment(d),
  update:              (id, d) => LedgerAPI.updatePayment(id, d),
  delete:              (id) => LedgerAPI.deletePayment(id),
  getRegular:          () => LedgerAPI.getRegular(getSocietyId()),
  getRegularDefaults:  () => LedgerAPI.getRegularDefaults(),
  getSupplementary:    () => LedgerAPI.getSupplementary(getSocietyId()),
  addSupplementary:    (d) => LedgerAPI.createSupplementary(d),
  updateSupplementary: (id, d) => LedgerAPI.updateSupplementary(id, d),
  deleteSupplementary: (id) => LedgerAPI.deleteSupplementary(id),
};

export const BudgetController = {
  getAll:  () => BudgetAPI.getAll(getSocietyId()),
  add:     (d) => BudgetAPI.create({ ...d, societyId: getSocietyId() }),
  update:  (id, d) => BudgetAPI.update(id, d),
  delete:  (id) => BudgetAPI.delete(id),
};

// Placeholders for pages without backend endpoints yet
const noopStore = () => ({
  getAll:  () => Promise.resolve([]),
  add:     () => Promise.resolve(null),
  update:  () => Promise.resolve(null),
  delete:  () => Promise.resolve(null),
  search:  () => Promise.resolve([]),
});

export const ChargesController        = noopStore();
export const BillParametersController = noopStore();
export const VendorController         = noopStore();
export const VendorContractController = noopStore();
export const VendorBillingController  = noopStore();
export const ReceiptsController       = noopStore();
export const PaymentsController       = noopStore();
export const JVController             = noopStore();
export const FDController             = noopStore();
export const PendingApprovalController= noopStore();
export const RegularChargesController = { getAll: () => LedgerAPI.getRegular(getSocietyId()) };

export const DashboardController = {
  getSummary: async () => {
    try {
      const banks = await BankCashAPI.getAll();
      const totalBank = banks.filter(b => b.accountType === 'BANK').reduce((s, b) => s + (b.openingBalance || 0), 0);
      const totalCash = banks.filter(b => b.accountType === 'CASH').reduce((s, b) => s + (b.openingBalance || 0), 0);
      return { totalBank, totalCash, totalReceipts: 0, totalPayments: 0, pendingVendor: 0, totalFD: 0 };
    } catch (_) {
      return { totalBank: 0, totalCash: 0, totalReceipts: 0, totalPayments: 0, pendingVendor: 0, totalFD: 0 };
    }
  },
};
